/**
 * Stanlee Book a Demo — page-scoped JS.
 *
 * Responsibilities only:
 *  1. Read the `product` query parameter and pre-select the matching
 *     product card, if present in the configured demo collection.
 *  2. Keep the hidden contact[Product Model] / contact[Product URL]
 *     fields in sync with whichever product card is checked.
 *  3. Toggle between the "selected product" summary and the full
 *     product picker grid.
 *
 * No global listeners, no fetch, no AJAX submission. All logic is
 * scoped to elements inside [data-sbd-root]; if that root isn't on
 * the page, this file does nothing.
 */
(function () {
  var root = document.querySelector('[data-sbd-root]');
  if (!root) return;

  var productInputs = root.querySelectorAll('[data-sbd-product-input]');
  var hiddenModel = root.querySelector('[id^="SbdProductModel-"]');
  var hiddenUrl = root.querySelector('[id^="SbdProductUrl-"]');
  var pickerFieldset = root.querySelector('[data-sbd-product-picker]');
  var selectedWrap = root.querySelector('[data-sbd-selected-product]');
  var selectedTitle = root.querySelector('[data-sbd-selected-title]');
  var selectedPrice = root.querySelector('[data-sbd-selected-price]');
  var selectedImage = root.querySelector('[data-sbd-selected-image]');
  var changeProductBtn = root.querySelector('[data-sbd-change-product]');

  function syncHiddenFields(input) {
    if (!input) return;
    if (hiddenModel) hiddenModel.value = input.getAttribute('data-title') || '';
    if (hiddenUrl) hiddenUrl.value = input.getAttribute('data-url') || '';
  }

  function showSelectedSummary(input) {
    if (!selectedWrap || !input) return;

    if (selectedTitle) selectedTitle.textContent = input.getAttribute('data-title') || '';
    if (selectedPrice) selectedPrice.textContent = input.getAttribute('data-price') || '';

    var imageSrc = input.getAttribute('data-image');
    if (selectedImage) {
      if (imageSrc) {
        selectedImage.src = imageSrc;
        selectedImage.alt = input.getAttribute('data-title') || '';
        selectedImage.hidden = false;
      } else {
        selectedImage.hidden = true;
      }
    }

    selectedWrap.hidden = false;
    if (pickerFieldset) pickerFieldset.hidden = true;
  }

  function showPicker() {
    if (pickerFieldset) pickerFieldset.hidden = false;
    if (selectedWrap) selectedWrap.hidden = true;
  }

  // Keep hidden fields in sync whenever the user picks a product manually.
  productInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      syncHiddenFields(input);
    });
  });

  // Pre-select from ?product= query param, if present and valid.
  var params = new URLSearchParams(window.location.search);
  var productParam = params.get('product');

  if (productParam) {
    var match = null;
    productInputs.forEach(function (input) {
      if (input.getAttribute('data-handle') === productParam) {
        match = input;
      }
    });

    if (match) {
      match.checked = true;
      syncHiddenFields(match);
      showSelectedSummary(match);
    }
  }

  if (changeProductBtn) {
    changeProductBtn.addEventListener('click', function () {
      showPicker();
    });
  }
})();
